import type { ReactNode } from 'react';
import { CountUp } from '@/components/ui/CountUp';

export interface Kpi {
  label: string;
  value: ReactNode;
  /** ערך מספרי — כשקיים, המספר "נספר" אליו (count-up) ו-format מציג אותו. */
  num?: number;
  format?: (v: number) => string;
  /** צבע הערך (טוקן) — למשל var(--warn) למדד שדורש תשומת לב. */
  tone?: string;
  hint?: ReactNode;
}

/**
 * פס מדדים בעיצוב v2 — כרטיס אחד, מספרים גדולים ודקים עם קו מפריד עדין
 * ביניהם (כמו "שיחות שיצאו / שנענו / אחוז מענה" במסך הביצועים).
 * מספרים נספרים מ-0 בכניסה (1.1ש) וממשיכים מהערך הנוכחי בעדכון.
 */
export function KpiStrip({ items, ariaLabel, delay }: { items: Kpi[]; ariaLabel?: string; delay?: string }) {
  if (items.length === 0) return null;
  return (
    <div className="card" role="group" aria-label={ariaLabel} style={{ padding: '22px 10px', display: 'flex', flexWrap: 'wrap', rowGap: 18, ...(delay ? { ['--d' as string]: delay } : null) }}>
      {items.map((k, i) => (
        <div
          key={k.label}
          style={{
            flex: '1 1 150px', display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0,
            paddingInline: 18, borderInlineStart: i === 0 ? undefined : '1px solid var(--line)',
          }}
        >
          <span style={{ fontSize: 12.5, color: 'var(--text-2)' }}>{k.label}</span>
          <span
            style={{
              fontSize: 34, fontWeight: 300, lineHeight: 1.05, letterSpacing: -1.3,
              fontVariantNumeric: 'tabular-nums', color: k.tone ?? 'var(--text)', whiteSpace: 'nowrap',
            }}
          >
            {k.num != null ? <CountUp value={k.num} format={k.format} /> : k.value}
          </span>
          {k.hint && <span style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)' }}>{k.hint}</span>}
        </div>
      ))}
    </div>
  );
}
